<template>
  <RadioGroup
    v-model="item.value"
    @on-change="(val) => { item.onChange && item.onChange(item, formItems) }"
  >
    <Radio v-for="o in (item.radios || [])" :key="o.value" border :label="o.value" :disabled="readonly || item.disabled">{{o.text}}</Radio>
  </RadioGroup>
</template>
<script>
import props from './props'
export default {
  name: 'form-item-radio',
  mixins: [props],
  data () {
    return {}
  }
}
</script>